export class SetGroupRoleError {
  public static readonly type = '[Authorisation] SetGroupRoleError';
  constructor(public readonly error: Error) {}
}
